import { phoneFormation } from '@helpers/phoneFormation';
import { PhoneTypeProps } from './TypeProps';
import { MyLink } from '@ui-kit/MyLink';

export const Phone = ({ phone, className }: PhoneTypeProps) => {
  const formPhone = phoneFormation(phone);
  if (phone) {
    return (
      <MyLink color={'black'} className={className} href={formPhone.url}>
        {phone && formPhone.phone}
      </MyLink>
    );
  }
};
